/* 🤖 this file was generated by svg-to-ts */
export const mgcIconCloudFilled: {
  name: 'cloud-filled';
  data: string;
} = {
  name: 'cloud-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.72 4.041c-1.446.201-2.685.787-3.675 1.739-1.235 1.187-1.896 2.585-2.026 4.282l-.028.362-.343.175a4.793 4.793 0 0 0-1.269.967c-1.654 1.725-1.833 4.411-.426 6.369.276.383.856.945 1.238 1.199.647.43 1.456.732 2.208.824.461.057 9.702.057 10.233.001a5.92 5.92 0 0 0 3.497-1.634c2.114-2.029 2.464-5.211.843-7.662-.345-.523-1.129-1.311-1.628-1.639-.412-.272-1.079-.599-1.474-.724l-.274-.087-.175-.388a6.542 6.542 0 0 0-4.782-3.728c-.399-.074-1.547-.108-1.919-.056"/></svg>`
};
